import { LandingNav } from './components/LandingNav';
import { HeroSection } from './components/HeroSection';
import { TrustBadgesSection } from './components/TrustBadgesSection';
import { TheProblemSection } from './components/TheProblemSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { DashboardShowcaseSection } from './components/DashboardShowcaseSection';
import { FeaturesSection } from './components/FeaturesSection';
import { WhyChooseUsSection } from './components/WhyChooseUsSection';
import { ROICalculatorSection } from './components/ROICalculatorSection';
import { IntegrationPartnersSection } from './components/IntegrationPartnersSection';
import { PricingSection } from './components/PricingSection';
import { SocialProofSection } from './components/SocialProofSection';
import { FAQSection } from './components/FAQSection';
import { TeamSection } from './components/TeamSection';
import { WaitlistSection } from './components/WaitlistSection';
import { DemoSection } from './components/DemoSection';
import { CTABannerSection } from './components/CTABannerSection';
import { LandingFooter } from './components/LandingFooter';

export function LandingPage() {
  return (
    <div className="min-h-screen bg-background">
      <LandingNav />
      <main>
        {/* 1. Hero */}
        <HeroSection />
        {/* 2. Trust Badges */}
        <TrustBadgesSection />
        {/* 3. The Problem */}
        <TheProblemSection />
        {/* 4. How It Works */}
        <HowItWorksSection />
        {/* 5. Dashboard Showcase */}
        <DashboardShowcaseSection />
        {/* 6. Features */}
        <FeaturesSection />
        {/* 7. Why Choose Us */}
        <WhyChooseUsSection />
        {/* 8. ROI Calculator */}
        <ROICalculatorSection />
        {/* 9. Integration Partners */}
        <IntegrationPartnersSection />
        {/* 10. Pricing */}
        <PricingSection />
        {/* 11. Testimonials / Social Proof */}
        <SocialProofSection />
        {/* 12. FAQ */}
        <FAQSection />
        {/* 13. Team */}
        <TeamSection />
        {/* 14. Waitlist */}
        <WaitlistSection />
        {/* 15. Demo */}
        <DemoSection />
        {/* 16. CTA Banner */}
        <CTABannerSection />
      </main>
      <LandingFooter />
    </div>
  );
}
